export default __webpack_public_path__ + "static/media/fan-mod.15af9dc1.png";